import React from 'react'
import Resturant from './Components/Resturant/Resturant'


function App() {
  return (
    <div>
      <Resturant />
      
    </div>
  )
}

export default App
